import { lazyWithRetry } from '@tools/utils/lazyWithRetry.ts';

import type { ComponentOrMapping, ComponentPage } from '@cfg/pageRoutes.tsx';

/**
 * Rutas del módulo de Suscripciones (ERP)
 *
 * Define las rutas para la gestión de planes de suscripción,
 * suscripciones de clientes, y uso de créditos.
 */

// Carga perezosa de las páginas
export const SubscriptionPlansPage = lazyWithRetry(() =>
  import('@features/erp/subscriptions/pages/SubscriptionPlansPage.tsx'),
);

export const CustomerSubscriptionsPage = lazyWithRetry(() =>
  import('@features/erp/subscriptions/pages/CustomerSubscriptionsPage.tsx'),
);

// Configuración del nodo de planes
const plansNode = {
  component: SubscriptionPlansPage,
} satisfies ComponentPage;

// Configuración del nodo de suscripciones de clientes
const customersNode = {
  component: CustomerSubscriptionsPage,
} satisfies ComponentPage;

// Estructura de rutas para subscriptions
// Ruta resultante: /erp/subscriptions/plans y /erp/subscriptions/customers
const subscriptionsRoutes: ComponentOrMapping = {
  erp: {
    subscriptions: {
      plans: plansNode,
      customers: customersNode,
    },
  },
};

export default subscriptionsRoutes;

